/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcDtccDrecoV1AssetState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_DTCC_DRECO_V1_ASSET_STATE_ENTITY_NAME = 'ixc.dtcc.dreco.v1.Asset';
export const ixcDtccDrecoV1AssetStateEntity = new schema.Entity<IxcDtccDrecoV1AssetState>(IXC_DTCC_DRECO_V1_ASSET_STATE_ENTITY_NAME, {}, { idAttribute: 'assetId' });

